import axios from "axios";
import {BaseResponse} from "../../../BaseResponse";

export async function deleteTankReleaseCertificate(tankReleaseId: string, tankReleaseCertificateId: string) {
    const response = await axios.delete<BaseResponse<boolean>>(`/tank/release/${tankReleaseId}/certificate/${tankReleaseCertificateId}`)

    return response.data
}